import { emphasize, keyframes } from '@mui/material';

/** Shared attention-grabbing box-shadow pulse, used to nudge the user towards an input/action */
export const pulseGlow = (color: string) => keyframes`
  from, to {
    box-shadow: 0 0 0 1px ${emphasize(color, 0.25)};
  }

  50% {
    box-shadow: 0 0 8px 4px ${emphasize(color, 0.2)};
  }
`;
